import { YoutubeSetupInterface } from '../../../../ng-services/livestreams/YoutubeSetupInterface';
import { SocialLoginService } from '../../../../ng-services/social-login.service';
import { YoutubeApiService } from '../../../../ng-services/youtube-api.service';
import { getYoutubeIdFromUrl, isValidYoutubeId } from '../../../../services/youtube-util';

export class LivestreamSetupYoutubeBodyComponent {
    static $inject = ['$scope', 'SocialLoginService', 'YoutubeApiService'];

    value!: YoutubeSetupInterface;

    advancedCollapsed = true;

    isLoggedIn = false;
    token?: string;

    fetchingYoutube = false;
    livestreams: any; // todo: typings
    broadcasts: any;

    selectedLivestream: any; // todo: typings
    selectedBroadcast: any;

    showHelp: boolean = false;

    onSave: any;

    constructor(
        private $scope: ng.IScope,
        private socialLoginService: SocialLoginService,
        private youtubeApiService: YoutubeApiService
    ) {}

    googleLogin() {
        return this.socialLoginService.signIn();
    }

    onLoginSuccess(token: string) {
        this.isLoggedIn = true;
        this.token = token;

        this.fetchYoutubeUrls();
    }

    async fetchYoutubeUrls() {
        this.fetchingYoutube = true;
        if (!this.token) {
            return;
        }

        this.livestreams = await this.youtubeApiService.getLiveStreamsList(this.token);
        this.broadcasts = await this.youtubeApiService.getLiveBroadcastList(this.token);

        this.fetchingYoutube = false;

        this.$scope.$digest();
    }

    save(form: ng.IFormController) {
        if (form.$invalid) {
            return;
        }

        const setup: YoutubeSetupInterface = {
            streamKey: this.selectedLivestream?.cdn?.ingestionInfo?.streamName || this.value.streamKey,
            streamUrl: this.selectedBroadcast?.id || this.value.streamUrl,
        };

        this.onSave && this.onSave({ setup });
    }
}

// todo: move somewhere else if needed
angular.module('tradersyard').directive('isValidYoutubeUrl', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl: any) {
            ctrl.$validators.isValidYoutubeUrl = function (modelValue: ng.INgModelController, viewValue: any) {
                if (ctrl.$isEmpty(modelValue)) {
                    return true;
                }

                try {
                    const youtubeId = getYoutubeIdFromUrl(viewValue);

                    return isValidYoutubeId(youtubeId);
                } catch (e) {
                    // invalid url
                    return false;
                }
            };
        },
    };
});

angular.module('tradersyard').component('tyLivestreamSetupYoutubeBodyComponent', {
    template: require('./livestream-setup-youtube-body.component.html').default,
    controller: LivestreamSetupYoutubeBodyComponent,
    bindings: {
        close: '&',
        onSave: '&',
        value: '<',
    },
});
